import { CSSObject, Group, TextInput } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import EmailChip from './EmailChip';
import useEmailChipsInput from './useEmailChipsInput';

const TEXT_INPUT_STYLES = {
	input: {
		'height': '30px',
		...textVariants.footnote,
		'color': 'var(--color-text-primary)',
		'&::placeholder': {
			color: 'var(--color-text-light)'
		}
	} as CSSObject
};

type EmailChipsInputProps = {
	emails: string[];
	onEmailsChange: ( emails: string[] ) => void;
	emailValidator?: ( email: string ) => boolean;
	placeholder?: string;
	disabled?: boolean;
};

const EmailChipsInput = ( {
	emails,
	onEmailsChange,
	emailValidator = () => true,
	placeholder = 'Enter Email',
	disabled = false
}: EmailChipsInputProps ) => {
	const {
		inputValue,
		onKeyDown,
		onInputChange,
		onDeleteClick,
		onPaste,
		onBlur
	} = useEmailChipsInput( { emails, onEmailsChange } );

	const hasEmails = emails.length > 0;

	return (
		<Group
			spacing={8}
			align="center"
			style={{ flex: '1 1 0', minWidth: 0, flexWrap: 'wrap', rowGap: 6 }}
			w="100%"
		>
			{hasEmails && emails.map( email => (
				<EmailChip
					key={email}
					email={email}
					isValid={emailValidator( email )}
					onDeleteClick={onDeleteClick}
				/>
			) )}
			<TextInput
				placeholder={hasEmails ? '' : placeholder}
				variant="unstyled"
				styles={TEXT_INPUT_STYLES}
				value={inputValue}
				onChange={onInputChange}
				onKeyDown={onKeyDown}
				onPaste={onPaste}
				onBlur={onBlur}
				disabled={disabled}
				style={{ flex: '1 1 100px', minWidth: 100 }}
			/>
		</Group>
	);
};

export default EmailChipsInput;
